import React from "react";
import { Card, Empty, Row, Col } from "antd";

const darkCardStyle = {
  borderRadius: 12,
  background: "#1f1f1f",
  color: "#fff",
  border: "1px solid #333",
  marginBottom: 16,
};

const formatDate = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("id-ID", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// custom tag pakai div biar bisa kontrol penuh
const CustomTag = ({ text, bgColor }) => (
  <div
    style={{
      backgroundColor: bgColor,
      color: "#fff",
      padding: "4px 12px",
      borderRadius: 8,
      fontSize: 13,
      fontWeight: 600,
    }}
  >
    {text}
  </div>
);

const CustomerOrderCards = ({ orders }) => {
  if (!orders || orders.length === 0) {
    return (
      <Card style={darkCardStyle} bordered={false}>
        <Empty
          description={
            <span style={{ color: "#fff" }}>Data keepan tidak ditemukan</span>
          }
        />
      </Card>
    );
  }

  return (
    <Row gutter={[16, 16]}>
      {orders.map((order, key) => (
        <Col xs={24} sm={20} md={16} key={key}>
          <Card style={darkCardStyle} bordered={false}>
            {/* Header: Tanggal + Subtotal */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 8,
              }}
            >
              <div style={{ fontSize: 14, color: "#aaa" }}>
                {formatDate(order.TglTransaksi)}
              </div>
              <CustomTag
                text={order.SendFlag ? "Terkirim" : "Belum Dikirim"}
                bgColor={order.SendFlag ? "#52c41a" : "#ff4d4f"}
              />
            </div>

            {/* Pesanan */}
            <div
              style={{
                fontSize: 16,
                fontWeight: "bold",
                color: "#4cafef",
              }}
            >
              Rp {order.SubTotal.toLocaleString("id-ID")}
            </div>
            <div
              style={{
                fontSize: 15,
                margin: "8px 0",
                color: "#fff",
                fontWeight: 500,
              }}
            >
              {order.Pesanan}
            </div>

            {/* Placement & Status */}
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              <CustomTag
                text={order.Placement || "Belum Disimpan"}
                bgColor="#1890ff"
              />
              <CustomTag
                text={`Dikeep Oleh: ${order.updateBy}`}
                bgColor="#722ed1"
              />
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default CustomerOrderCards;
